import { render, staticRenderFns } from "./CreateConference.vue?vue&type=template&id=f34abbac&scoped=true&"
import script from "./CreateConference.vue?vue&type=script&lang=js&"
export * from "./CreateConference.vue?vue&type=script&lang=js&"
import style0 from "./CreateConference.vue?vue&type=style&index=0&id=f34abbac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34abbac",
  null
  
)

export default component.exports